// extracted by mini-css-extract-plugin
var _1 = "PerkItem_perk__rlCm5";
var _2 = "PerkItem_perkExcluded__lvWYc";
var _3 = "PerkItem_perkIcon__LTUQv";
var _4 = "PerkItem_perkText__hzvGO";
var _5 = "PerkItem_plansTooltip__IcX3c";
var _6 = "PerkItem_plansTooltipShort__y26WN";
export { _1 as "perk", _2 as "perkExcluded", _3 as "perkIcon", _4 as "perkText", _5 as "plansTooltip", _6 as "plansTooltipShort" }
